export const closingTimeName = 'closing_time';
export const manualDurationName = 'manual_time';
export const closingTimeValue = 0;
export const ACCEPT_ORDERS_UNTIL_LABEL = { basic: true, content: 'minutes' };
